'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { CatalogRequestParams } from '@/src/lib/category/types.ts';
import { SelectOption } from '@/src/types/select-option.ts';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import Select from '@/src/app/components/Select/Select.tsx';
type IPPSelectProps = {
  ippOptions: Array<SelectOption>;
  dict: Dictionary;
  selectedOption: number;
  onChange: (option: SelectOption, searchParam: CatalogRequestParams) => void;
};
function IppSelect(t0) {
  const $ = _c(8);
  const {
    ippOptions,
    dict,
    selectedOption,
    onChange
  } = t0;
  const {
    isPending
  } = useContext(LayoutTemplateContext);
  let t1;
  if ($[0] !== onChange) {
    t1 = option => onChange(option, CatalogRequestParams.IPP);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dict.category.ipp || $[3] !== ippOptions || $[4] !== isPending || $[5] !== selectedOption || $[6] !== t1) {
    t2 = <Select value={selectedOption} options={ippOptions} label={dict.category.ipp} placeholder={dict.category.ipp} name="ipp-category" className="w-1/2 lg:min-w-[8.75rem]" disabled={isPending} onSelectionChangeHook={t1} />;
    $[2] = dict.category.ipp;
    $[3] = ippOptions;
    $[4] = isPending;
    $[5] = selectedOption;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export default IppSelect;